import { observable } from 'mobx';

// This was previously declared within getExperimentSegment.js, but since that now calls noticeError()
// which references this structure, it has been separated to avoid a dependency cycle with noticeError()
export default observable.map();
